<div *ngFor="let year of yearsArray">
  <tc-single-year
    id="{{'cg-cal-year-'+year}}"
    [year]="year"
    [rangeGroups]="rangeGroups"
    [calendarRefreshEvent]="calendarRefreshEvent"
    (selectDate)="onSelectDate($event)">
  </tc-single-year>
</div>
